export const Cell = ({
  cell,
  x,
  y,
  content = "",
  confirmationCell,
  onClick,
  setHoverCell,
}) => (
  <div
    className={
      "cell unknown " + cell.status + (confirmationCell ? " bold" : "")
    }
    draggable="false"
    data-x={x}
    data-y={y}
    onClick={onClick}
    onMouseEnter={() => setHoverCell?.({ x, y })}
    onMouseLeave={() => setHoverCell?.({ x: null, y: null })}
  />
)
